<div class="select-bulma is-rounded mb-30 w-100">
  <select class="bg-gray" [(ngModel)]="control.value" #name="ngModel" [name]="control.name" [required]="control.required">
    <option *ngFor="let option of getOptions()" [value]="option.value" [appTranslate]="option.text"></option>
  </select>
</div>
